import React from 'react';
import { Box, Typography } from '@mui/material';
import MacroCycleDashboard from '../components/MacroCycleDashboard';
import { bloomberg } from '../theme/bloombergTheme';

/**
 * The macro / economy page.
 *
 * Previously this page was three tabs — Sectors, Industry, Economy — where the
 * first two were equity sector rotation and only the third was macro. That made
 * the nav item labelled "Macro" point mostly at sector performance, and buried
 * the economic series behind two clicks with no way to link to them.
 *
 * The sector and industry views now live on Market Map (which already does
 * sector visualisation) as MarketPerformancePanels, and this page is what its
 * name claims: the economy.
 */
const MacroOverview: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 1600, mx: 'auto' }}>
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 600, color: bloomberg.text.primary }}>
        Macro
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Economic cycle, credit, rates and positioning — FRED, ECB, Bundesbank, Bank of
        England, Japan MOF, Bank of Canada, OECD, DBnomics, CFTC, CBOE and AAII
      </Typography>
    </Box>
    <MacroCycleDashboard />
  </Box>
);

export default MacroOverview;
